(() => {
	angular
		.module('main')
		.controller('InvoiceViewController', InvoiceViewController);

	InvoiceViewController.$inject = [
		'$scope',
		'$rootScope',
		'$routeParams',
		'$location',
		'$http',
		'jobDataService',
		'messageService',
		'fileUploadService',
		'validationService',
		'emailService',
		'invoicesDataService'
	];

	function InvoiceViewController(
		$scope,
		$rootScope,
		$routeParams,
		$location,
		$http,
		jobDataService,
		messageService,
		fileUploadService,
		validationService,
		emailService,
		invoicesDataService
	) {
		$scope.data = {};

		$scope.$on('$viewContentLoaded', () => {
			$scope.invoiceId = $routeParams.id;
		});

		$scope.sendMessage = {};
		$scope.sendMessage.emailTo = [];
		$scope.sendMessage.addInvoiceAttachment = true;
		$scope.attachmentsData = {
			attachments: [],
			filesSize: 0
		};
		let isFirstShow = true;

		$scope.setEmailData = (newData, object, property) => {
			$scope[object][property] = newData;
		};

		$scope.toggleViewCc = function(state) {
			if ($scope.sendMessage && $scope.sendMessage.emailCc) {
				$scope.sendMessage.emailCc = [];
			}

			if ($scope.sendMessage && !$scope.sendMessage.addInvoiceAttachment) {
				$scope.sendMessage.addInvoiceAttachment = true;
			}

			$scope.showCcField = state !== undefined ? state : !$scope.showCcField;

			if (state === false) {
				isFirstShow = false;
				$scope.sendMessage.emailTo = [];
				$scope.attachmentsData = {
					attachments: [],
					filesSize: 0
				};
			}
		};

		$scope.addContactMail = function(contactEmail) {
			$scope.contactEmail = contactEmail;
		};

		$scope.addSubjectVariable = function($event, id) {
			const el = document.getElementById(id);
			$scope.sendMessage.emailSubject = emailService.addSubjectVariable(
				el,
				$event
			);
		};

		// Email methods
		$scope.retrySendMail = function() {
			getInvoiceInformation($routeParams.id);
			emailService.callLastEmailFn();
		};

		$scope.showSendInvoice = function({ isReceipt, data, invoice }) {
			$scope.isSendReceiptSpinnningWheelActive = true;
			$rootScope.backId = $scope.data.id;
			$scope.receiptId = data.id;
			if (invoice.job.secondaryContact) {
				$scope.secondaryContactEmail = invoice.job.secondaryContact.email;
			}
			delete $scope.sendMessage;
			$scope.sendMessage = {};
			$scope.emailDataToSave = {};
			$scope.sendMessage.addInvoiceAttachment = true;
			$scope.sendReceipt = !!isReceipt;

			$http.get('/protected/rest/email_templates/get').then(
				result => {
					if (result.data) {
						$scope.$evalAsync();

						$scope.emails = result.data;

						if ($scope.emails) {
							const template = isReceipt
								? 'RECEIPT_OF_PAYMENT_EMAIL_TEMPLATE'
								: 'INVOICE_EMAIL_TEMPLATE';
							$scope.choosenEmail =
								$scope.emails.find(
									item => item.emailTemplateType === template
								) || {};
						}
						$('#sendInvoiceModal')
							.modal('show')
							.on('shown.bs.modal', () => {
								const input = $('#sendInvoiceModal').find('input');

								validationService.isModalClosePrevented(input);
							});
					}
					$scope.isSendReceiptSpinnningWheelActive = false;
				},
				() => {
					$scope.isSendReceiptSpinnningWheelActive = false;
				}
			);
		};

		$scope.$watch('choosenEmail', newValue => {
			if (typeof newValue !== 'undefined' && newValue != null) {
				$http
					.get(
						`/protected/rest/settings/email_template/get/${
							newValue.id
						}?forSend=true`
					)
					.then(result => successGetEmailTemplate(result.data));
			}
		});

		function successGetEmailTemplate(email) {
			if (email) {
				$scope.sendMessage.emailSubject = email.subject;
				$scope.sendMessage.emailText = email.text.replace(
					/class="linkEdited"/g,
					'class=""'
				);
				if (email.storedAttachments && email.storedAttachments.length) {
					$scope.attachmentsData = {
						attachments: fileUploadService.convertAttachmentsToShow(
							email.storedAttachments
						)
					};
				} else {
					clearAttachments();
				}

				const rootEmail = $rootScope.primaryContact
					? $rootScope.primaryContact.email || ''
					: '';
				$scope.sendMessage.emailTo = $scope.contactEmail
					? [$scope.contactEmail]
					: [] || rootEmail
						? [rootEmail]
						: [];
				if ($scope.secondaryContactEmail) {
					$scope.sendMessage.emailTo.push($scope.secondaryContactEmail);
				}
				$scope.sendMessage.emailCc = [];
			}
		}

		$scope.sendInvoice = function() {
			const maxSize = 10; // 10Mb

			if (
				$scope.attachmentsData &&
				$scope.attachmentsData.filesSize > maxSize
			) {
				messageService.showToaster('w_0', 'attachments');
				return false;
			}

			let url;

			if (typeof $rootScope.backId === 'undefined') {
				$rootScope.backId = $routeParams.id;
			}

			const sendInvoiceFromInvoiceViewUrl = `/protected/rest/invoices/invoice/send/${
				$rootScope.backId
			}`;
			const sendInvoiceFromJobViewUrl = `/protected/rest/invoices/invoice/send/${
				$routeParams.id
			}`;
			const sendReceiptUrl = `/protected/rest/payment-receipt/${
				$scope.receiptId
			}/send`;

			$scope.$evalAsync();

			if ($location.path().includes('invoices')) {
				url = $scope.sendReceipt
					? sendReceiptUrl
					: sendInvoiceFromInvoiceViewUrl;
			} else {
				url = sendInvoiceFromJobViewUrl;
			}

			$scope.sendMessage.templateId = $scope.choosenEmail
				? $scope.choosenEmail.id
				: '';
			$scope.sendMessage.emailText = $rootScope.addMaiStyling(
				$scope.sendMessage.emailText
			);

			const mailData = emailService.prepareEmails($scope.sendMessage);

			if (!emailService.validateMails(mailData)) {
				return;
			}

			$scope.emailDataToSave = Object.assign({}, $scope.sendMessage, mailData);
			delete $scope.emailDataToSave.emailCc;

			$scope.isSendInvoiceSpinnningWheelActive = true;
			$scope.disableBtnOnSend = true;
			const obj2save = angular.copy($scope.emailDataToSave);

			$scope.sendMessage.emailCc = $scope.showCcField ? obj2save.emailCc : '';
			const formData = new FormData();
			angular.forEach($scope.emailDataToSave, (value, key) => {
				formData.append(key, value);
			});
			const storedFiles = $scope.attachmentsData.attachments.filter(
				file => file.id
			);
			const uploadedFiles = $scope.attachmentsData.attachments.filter(
				file => !file.id
			);

			angular.forEach(uploadedFiles, (value, key) => {
				formData.append(`attachments[${key}]`, value);
			});

			angular.forEach(storedFiles, (value, key) => {
				formData.append(`storedAttachments[${key}]`, value.id);
			});

			invoicesDataService
				.sendInvoiceRequest(url, formData)
				.finally(() => ($scope.isSendInvoiceSpinnningWheelActive = false))
				.subscribe(successSendInvoice, errorSendInvoice);
		};

		function successSendInvoice() {
			isFirstShow = false;
			$('#sendInvoiceModal').modal('hide');
			$scope.disableBtnOnSend = false;
			$scope.showCcField = false;

			$scope.$evalAsync();

			clearAttachments();
			$scope.isJobView = $location.path().includes('/jobs/view/');
			$scope.isLeadView = $location.path().includes('/leads/view/');
			if ($scope.isJobView) {
				invoicesDataService.emitInvoiceUpdateEvent('UPDATE_SN_INVOICES');
				$rootScope.updateJobView();
			} else if ($scope.isLeadView) {
				$rootScope.updateLeadView();
				invoicesDataService.emitInvoiceUpdateEvent('UPDATE_SN_INVOICES');
			}

			const messageCode = $scope.sendReceipt ? 's_11' : 's_9';

			messageService.showToaster(messageCode, 'payments');

			const path = $location.path();

			if (path.includes('payments') || path.includes('invoices')) {
				snCommunicationAdapter.callMethod('getInvoice');
			}
		}

		function errorSendInvoice({ status, data, error }) {
			$scope.disableBtnOnSend = false;

			const { errorMessage, errorTitle } = error;
			let errorCode, errorPlace, value;

			if (status >= 400 && status < 500 && data.errorMessage) {
				if (status == 423) {
					const limit = $rootScope.isUserTrial ? 50 : 150;
					return messageService.showToaster('e_4', 'generalValidation', limit);
				} else if (
					data.errorMessage === 'Email text should contain an invoice link'
				) {
					const path = $location.path();
					const isNotInvoiceTemplate =
						path.includes('jobs') ||
						path.includes('payments') ||
						path.includes('invoices');

					errorPlace = isNotInvoiceTemplate ? 'editInvoice' : 'emailTemplate';

					if ($scope.sendReceipt) {
						errorCode = 'e_7';
					} else if (!$scope.sendReceipt && isNotInvoiceTemplate) {
						errorCode = 'e_3';
					} else {
						errorCode = 'e_0';
					}
				} else if (data.errorMessage.includes('Email address inactive')) {
					errorCode = 'e_1';
					errorPlace = 'generalValidation';
					value = $scope.sendMessage.emailTo;
				} else if (errorTitle) {
					messageService.showErrorFromBackend(errorTitle, errorMessage);
					return;
				} else {
					errorCode = 'e_2';
					errorPlace = 'general';
					value = errorMessage;
				}
			} else {
				errorCode = 'e_0';
				errorPlace = 'general';
			}
			messageService.showToaster(errorCode, errorPlace, value);
		}

		function clearAttachments() {
			if ($scope.attachmentsData && $scope.attachmentsData.attachments) {
				if ($scope.attachmentsData.attachments.length) {
					$scope.attachmentsData.attachments.length = 0;
				}
			}
		}

		$scope.disableDragDrop = () => true;

		function setMailData({ primaryContact, secondaryContact }) {
			$scope.contactEmail = primaryContact.email;
			if (secondaryContact) {
				$scope.secondaryContactEmail = secondaryContact.email;
			}
		}

		$(document).on('show.bs.modal', '#sendInvoiceModal', data => {
			if (isFirstShow) {
				isFirstShow = false;
				if (data.relatedTarget) {
					setMailData(data.relatedTarget);
				}
			}
			$scope.$broadcast('addedFileEvent');
		});
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/invoiceViewController.js